import MissionApp from './MissionApp';
import MissionsApp from './MissionsApp';
import {authRoles} from "../../../../store/actionreducers/auth/auth";

export const MedicalMissionsAppConfig = {
    auth: authRoles.medical, //  medicalAdmin
    routes: [
        {
            path: '/apps/institutionMission/:id',
            component: MissionApp
        },
        {
            path: '/apps/institutionMission',
            component: MissionsApp
        }
    ]
};



// WEBPACK FOOTER //
// ./src/main/content/adminMedical/mission/MissionsAppConfig.js